var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('img',{staticClass:"coverPic",attrs:{"src":_vm.detail.coverPath}}),_c('div',{staticClass:"content article",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }